/**
 * View split left and right parts, default 50% 50% relation
 *
 */
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
const useMeasureGridAreaStyles = makeThemedStyles(
  "MeasureGridArea",
  (theme) => ({
    root: {
      display: "inline-flex",
      width: "100%",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "20px",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
  })
);
const MeasureGridArea = (
  props: React.PropsWithChildren<{
    minWidth?: string;
  }>
) => {
  const styles = useMeasureGridAreaStyles();
  return (
    <div className={styles.root} style={{ minWidth: props.minWidth }}>
      {props.children}
    </div>
  );
};

export default MeasureGridArea;
